import React, { useMemo, useState } from 'react';
import Button from '../../../../generic-components/Button';
import { ReactComponent as SettingsIcon } from '../../../../assets/svg/filter-settings.svg';
import { ReactComponent as ActiveSettingsIcon } from '../../svg/filter-settings-active.svg';
import { STYLES } from '../../consts';
import { TransactionsPeriodTrigger } from './TransactionsPeriodTrigger';
import { FilterTypeAndAmountWrapper } from './FilterTypeAndAmountWrapper';
import { useStore } from '../../../../store';
import { ETypesFilter } from '../../hooks/useTransactionsData';

interface TransactionFilterProps {
  isCreditCardFilter?: boolean;
}

export const TransactionFilter = (props: TransactionFilterProps) => {
  const { isCreditCardFilter } = props;
  const [isTypeAndAmount, setIsTypeAndAmount] = useState<boolean>(false);
  const filterObject = useStore((state) => state.filterObject);
  const isSomeFilterActive = useMemo(
    () =>
      filterObject.transactionFilterType !== ETypesFilter.NONE || filterObject.amountFrom || filterObject.amountFrom,
    [filterObject],
  );
  return (
    <div className={STYLES.FILTER_WRAPPER}>
      <TransactionsPeriodTrigger />
      <div id='typeAndAmountTriggerWrapper' className='relative'>
        <Button
          onClick={() => setIsTypeAndAmount((prevState) => !prevState)}
          avoidStopPropagation
          className={STYLES.FILTER_TRIGGER}
          id='typeAndAmountTrigger'
          childElement={isSomeFilterActive ? <ActiveSettingsIcon /> : <SettingsIcon />}
        />
        {isTypeAndAmount && (
          <FilterTypeAndAmountWrapper
            onCloseFilter={() => setIsTypeAndAmount(false)}
            isCreditCardFilter={isCreditCardFilter}
          />
        )}
      </div>
    </div>
  );
};
